﻿import EventBase from './EventBase'
import EventID from './EventID'

import EventMediaPlayNode from './EventMediaPlayNode'

/**
 * 602 - 显示视频事件
 */

export default class EventMediaPlayShow extends EventBase {
  IsUi: boolean
  /**
   * 显示视频事件构造函数
   */
  constructor(UiFlag = false) {
    super()
    this.Parameter = [
      '0',
      '0',
      '',
      '0',
      '0',
      '0',
      '100',
      '100',
      '255',
      '0',
      '0',
      '1',
      '0',
      '0',
      '0',
    ]
    this.IsUi = UiFlag
  }
  /**
   * 事件ID
   */
  Code = EventID.MediaPlayAdd
  // #region 事件内关键属性参数
  /**
   * 视频ID
   */
  get VideoId() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set VideoId(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /// <summary>
  /// 指定的为橙光字符串索引
  /// 如果不存在则返回0
  /// </summary>
  get UserAssignedStrID() {
    return this.IsUserStrAssigned ? parseInt(this.Parameter?.[2] ?? '') : 0
  }
  set UserAssignedStrID(value) {
    this.Parameter &&
      (this.Parameter[2] = this.IsUserStrAssigned ? value.toString() : '0')
  }

  /**
   * 视频相对路径
   */
  get VideoPath() {
    return this.Parameter?.[2] || ''
  }
  set VideoPath(value) {
    this.Parameter && (this.Parameter[2] = value.toString())
  }

  /// <summary>
  /// 视频坐标是否为橙光数值指定
  /// 0为非数值指定（常量），1为是橙光动态数值指定
  /// </summary>
  get IsAssigned() {
    return this.Parameter?.[3] === '1'
  }
  set IsAssigned(value) {
    this.Parameter && (this.Parameter[3] = value ? '1' : '0')
  }

  /**
   * X坐标
   */
  get X() {
    return parseInt(this.Parameter?.[4] || '')
  }
  set X(value) {
    this.Parameter && (this.Parameter[4] = value.toString())
  }

  /**
   * Y坐标
   */
  get Y() {
    return parseInt(this.Parameter?.[5] || '')
  }
  set Y(value) {
    this.Parameter && (this.Parameter[5] = value.toString())
  }

  /**
   * X轴缩放率
   */
  get ZoomX() {
    return parseInt(this.Parameter?.[6] ?? '')
  }
  set ZoomX(value) {
    this.Parameter && (this.Parameter[6] = value.toString())
  }
  /**
   * Y轴缩放率
   */
  get ZoomY() {
    return parseInt(this.Parameter?.[7] ?? '')
  }
  set ZoomY(value) {
    this.Parameter && (this.Parameter[7] = value.toString())
  }

  /**
   * 视频透明度，0~255
   */
  get Opacity() {
    return parseInt(this.Parameter?.[8] ?? '')
  }
  set Opacity(value) {
    this.Parameter && (this.Parameter[8] = value.toString())
  }
  /// <summary>
  /// 是否使用了镜像功能
  /// 0否1是
  /// </summary>
  get IsMirror() {
    return this.Parameter?.[9] === '1'
  }
  set IsMirror(value) {
    this.Parameter && (this.Parameter[9] = value ? '1' : '0')
  }

  /**
   * 开始时间
   */
  get StratTime() {
    return parseInt(this.Parameter?.[10] ?? '')
  }
  set StratTime(value) {
    this.Parameter && (this.Parameter[10] = value.toString())
  }

  /**
   * 播放次数
   */
  get PlayNum() {
    return parseInt(this.Parameter?.[11] ?? '')
  }
  set PlayNum(value) {
    this.Parameter && (this.Parameter[11] = value.toString())
  }

  /**
   * 选择项
   */
  get ButtonChoice(): string[] {
    const list = new Array<string>()
    const list2 = new Array<EventMediaPlayNode>()
    if (this.Parameter != null) {
      list.push(...this.Parameter)
    }
    return list
  }
  set ButtonChoice(value) {
    this.Parameter = value


  }
  /// <summary>
  /// 是否素材来源自云网盘
  /// 2是（云网盘公有区资源）
  /// </summary>
  get IsPublicwebdisk() {
    return this.Parameter?.[10] == '2'
  }
  set IsPublicwebdisk(value) {
    this.Parameter && (this.Parameter[10] = value ? '2' : '1')
  }

  /// <summary>
  /// 视频名称是否为橙光字符串指定
  /// 0为是非字符串指定（固定视频），1为是橙光动态字符串指定
  /// </summary>
  get IsUserStrAssigned() {
    return this.Parameter?.[11] == '1'
  }
  set IsUserStrAssigned(value) {
    this.Parameter && (this.Parameter[11] = value ? '1' : '0')
  }
  /**
   * 字幕列表【字幕之间用;分隔，字幕内容之间用,分隔】开始时间1【毫秒】,结束时间1【毫秒】,字幕内容1;开始时间2【毫秒】,结束时间2【毫秒】,字幕内容2
   */
  get Subtitle() {
    return this.Parameter?.[12] || ''
  }
  set Subtitle(value) {
    this.Parameter && (this.Parameter[12] = value.toString())
  }

  /**
   * 停留或消除
   */
  get StayOrDisapear() {
    return parseInt(this.Parameter?.[13] ?? '')
  }
  set StayOrDisapear(value) {
    this.Parameter && (this.Parameter[13] = value.toString())
  }

  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter?.[14] || ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[14] = value.toString())
  }

  //   // #endregion

  /**
   * 获得该事件在事件列表的描述信息（对于显示视频而言，是第9项）
   */
  /// <returns>事件描述信息</returns>

  // TODO:
  public VideoDifChoice!: string[]
  //  public List<string> VideoDifChoice
  //   {
  //       get;
  //       set;
  //   }
}
